import styled from 'styled-components';

import { StyledComponent } from '../../../types/styledComponent.types';
import { InputContainer } from '../inputContainer/inputContainer.component';

export const StyledInputContainer: StyledComponent<typeof InputContainer> = styled(InputContainer)``;

export const Container: StyledComponent<'div'> = styled.div``;
